import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import NavBar from "./components/NavBar";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Checkout from "./pages/Checkout";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Receipt from "./pages/Receipt";
import CustomerDisplay from "./pages/CustomerDisplay";
import ShopSettings from "./pages/ShopSettings";
import Login from "./pages/Login";
import StaffManagement from "./pages/StaffManagement";
import SalesHistory from "./pages/SalesHistory";
import AccountSettings from "./pages/AccountSettings";
import SetupOwner from "./pages/SetupOwner";

function AppLayout() {
  const location = useLocation();

  // Hide navbar on login, setup, and customer-facing display
  const hideNav =
    location.pathname === "/login" ||
    location.pathname === "/setup-owner" ||
    location.pathname === "/customer-display";

  return (
    <>
      {!hideNav && <NavBar />}

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/setup-owner" element={<SetupOwner />} />
        <Route path="/customer-display" element={<CustomerDisplay />} />

        {/* STAFF + OWNER ROUTES */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/receipt/:saleId"
          element={
            <ProtectedRoute>
              <Receipt />
            </ProtectedRoute>
          }
        />

        {/* OWNER ONLY ROUTES */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute role="owner">
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/products"
          element={
            <ProtectedRoute role="owner">
              <Products />
            </ProtectedRoute>
          }
        />

        <Route
          path="/shop-settings"
          element={
            <ProtectedRoute role="owner">
              <ShopSettings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff"
          element={
            <ProtectedRoute role="owner">
              <StaffManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales-history"
          element={
            <ProtectedRoute role="owner">
              <SalesHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/account-settings"
          element={
            <ProtectedRoute role="owner">
              <AccountSettings />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;